"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 52.2 24",
    width: "52.2",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m6.84 9.52a.94.94 0 0 0 .36.08.81.81 0 0 0 .72-.44l2.17-4.36h1.91a.8.8 0 0 0 0-1.6h-2.4a.82.82 0 0 0 -.72.44l-2.4 4.8a.82.82 0 0 0 .36 1.08z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m51.4 16h-35.4v-15.2a.8.8 0 0 0 -.8-.8h-7.2a.81.81 0 0 0 -.7.41l-3.95 7.1-3.12 3.12a.81.81 0 0 0 -.23.57v8.8a.8.8 0 0 0 .8.8h3.35a3.9 3.9 0 0 0 7.69 0h18.16a.58.58 0 0 0 .19 0 3.9 3.9 0 1 0 6.81-3.24h2.16a3.86 3.86 0 0 0 -.95 2.53 3.9 3.9 0 0 0 7.75.67h5.44a.8.8 0 0 0 .8-.8v-3.16a.8.8 0 0 0 -.8-.8zm-6.93 4.09a2.35 2.35 0 1 1 -2.35-2.36 2.35 2.35 0 0 1 2.35 2.36zm-10.47-2.36a2.36 2.36 0 1 1 -2.36 2.36 2.36 2.36 0 0 1 2.36-2.36zm-29.48-9.16.13-.18 3.8-6.82h6v14.43h-12.89v-4.48zm3.48 9.16a2.36 2.36 0 1 1 -2.35 2.36 2.36 2.36 0 0 1 2.35-2.36zm-6.43-.17h3.43a3.87 3.87 0 0 0 -.84 1.65h-2.63zm10.22 1.64a3.93 3.93 0 0 0 -.79-1.64h20.07a4 4 0 0 0 -.85 1.68.78.78 0 0 0 -.22 0zm38.84 0h-4.71a3.94 3.94 0 0 0 -.84-1.64h5.55z"
  })));
};

exports["default"] = _default;